<template>
  <div
    class="s-percentageBasedLoadingIndicator"
    :class="{ '-large': large }"
    role="progressbar"
    :aria-valuenow="clampedPercentage"
    aria-valuemin="0"
    aria-valuemax="1"
    :style="{ width: size + 'px', height: size + 'px' }">
    <svg
      class="s-percentageBasedLoadingIndicator__svg"
      :width="size"
      :height="size"
      :viewBox="`0 0 ${size} ${size}`">
      <circle
        class="s-percentageBasedLoadingIndicator__track"
        :cx="half"
        :cy="half"
        :r="radius"
        fill="none"
        :stroke-width="strokeWidth" />
      <circle
        class="s-percentageBasedLoadingIndicator__progress"
        :cx="half"
        :cy="half"
        :r="radius"
        fill="none"
        :stroke-width="strokeWidth"
        :style="progressStyle" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'PercentageBasedLoadingIndicator',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    clampedPercentage() {
      const p = Number.isFinite(this.percentage) ? this.percentage : 0
      return Math.max(0, Math.min(1, p))
    },
    size() {
      return this.large ? 48 : 24
    },
    strokeWidth() {
      return this.large ? 6 : 4
    },
    half() {
      return this.size / 2
    },
    radius() {
      return this.half - (this.strokeWidth / 2)
    },
    circumference() {
      return 2 * Math.PI * this.radius
    },
    progressStyle() {
      const offset = (1 - this.clampedPercentage) * this.circumference
      return {
        strokeDasharray: `${this.circumference} ${this.circumference}`,
        strokeDashoffset: `${offset}`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/config';
.s-percentageBasedLoadingIndicator {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  box-shadow: 0 0 20px 5px rgba(255, 255, 255, 0.6);

  &__svg {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg); // start at 12 o'clock
  }

  &__track {
    stroke: transparent;
  }

  &__progress {
    stroke: $color-dark;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.2s ease-out;
  }
}
</style>
